/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_AboutInputs */

const en_footer_info_about = /** @type {(inputs: Footer_Info_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Us`)
};

/**
* | output |
* | --- |
* | "About Us" |
*
* @param {Footer_Info_AboutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_about = /** @type {((inputs?: Footer_Info_AboutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_AboutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_about(inputs)
});